import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { firebase, auth } from "../../../config/firebase_config";
import { register } from "../../../api/user";

const SignUpPage = () => {
    return (<></>);
};

export default SignUpPage;